module.exports = __webpack_public_path__ + "img/background.d3901565.png";